export const SELECT_PROPERTY_FIRST = 'Select Property First...';
export const SELECT_DOCKS = 'Select Dock(s)';
export const SELECT_USERS = 'Select User(s)';
